"use strict";

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertToRandomGenerator = void 0;

var ConvertedRandomGenerator = /*#__PURE__*/function () {
  function ConvertedRandomGenerator(rng) {
    _classCallCheck(this, ConvertedRandomGenerator);

    this.rng = rng;

    if (typeof this.rng.jump === 'function') {
      this.jump = function jump() {
        var out = this.jump();
        return new ConvertedRandomGenerator(out);
      };

      this.unsafeJump = function unsafeJump() {
        var out = this.jump();
        this.rng = out;
      };
    }
  }

  _createClass(ConvertedRandomGenerator, [{
    key: "min",
    value: function min() {
      return this.rng.min();
    }
  }, {
    key: "max",
    value: function max() {
      return this.rng.max();
    }
  }, {
    key: "clone",
    value: function clone() {
      return new ConvertedRandomGenerator(this.rng);
    }
  }, {
    key: "next",
    value: function next() {
      var out = this.rng.next();
      return [out[0], new ConvertedRandomGenerator(out[1])];
    }
  }, {
    key: "unsafeNext",
    value: function unsafeNext() {
      var out = this.rng.next();
      this.rng = out[1];
      return out[0];
    }
  }]);

  return ConvertedRandomGenerator;
}();

function convertToRandomGenerator(rng) {
  if ('clone' in rng && 'unsafeNext' in rng) {
    return rng;
  }

  return new ConvertedRandomGenerator(rng);
}

exports.convertToRandomGenerator = convertToRandomGenerator;